(function(){
  function applyJsUiToSections() {
    const sections = document.querySelectorAll('section[data-slider]');
    sections.forEach(section => {
      // marca a section como tendo js ativo
      section.setAttribute('data-slider-js', '1');

      // encontra o wrapper .slide (fallback para section)
      const slide = section.querySelector('.slide') || section;
      if (slide) {
        // só altera o overflow enquanto o JS está rodando
        // mantemos scroll-snap e outras propriedades intactas
        slide.style.overflow = 'hidden';
      }

      // mostra controls (se existirem)
      const controls = section.querySelector('.controls');
      if (controls) {
        controls.style.display = 'flex';
      }
    });
  }

  function isHorizontallyScrollable(el) {
    if (!el) return false;
    const style = getComputedStyle(el);
    const overflowX = style.overflowX;
    return (overflowX === 'auto' || overflowX === 'scroll') && el.scrollWidth > el.clientWidth;
  }

  function findScrollContainer(candidates) {
    for (const el of candidates) {
      if (!el) continue;
      if (isHorizontallyScrollable(el)) return el;
    }
    return candidates[0] || candidates[1] || candidates[2] || null;
  }

  function initAllSectionSliders() {
    const sections = document.querySelectorAll('section[data-slider]');
    sections.forEach(section => {
      const itemSelector = section.getAttribute('data-item-selector') || '.entry';
      const slide = section.querySelector('.slide') || section;
      const track = (slide && slide.querySelector('.slide-track')) || slide;

      if (!track) {
        console.warn('initAllSectionSliders: track não encontrado na seção', section);
        return;
      }

      const btnNext = section.querySelector('.slide-post-next, .slide-next');
      const btnPrev = section.querySelector('.slide-post-prev, .slide-prev');

      initSectionSliderInstance(section, slide, track, itemSelector, btnPrev, btnNext);
    });
  }

  function initSectionSliderInstance(section, slide, track, itemSelector, btnPrev, btnNext) {
    if (!track || !itemSelector) return;

    const scrollContainer = findScrollContainer([slide, track, section]);
    const getFirst = () => track.querySelector(itemSelector);
    const getAll   = () => Array.from(track.querySelectorAll(itemSelector));

    enableDragScroll(scrollContainer);

    function getStep() {
      const first = getFirst();
      if (!first) return 0;
      const w = first.offsetWidth || first.getBoundingClientRect().width || 0;
      const gap = parseInt(getComputedStyle(track).gap) || parseInt(getComputedStyle(first).marginRight) || 0;
      return w + gap;
    }

    function atStart(container) {
      return (container.scrollLeft <= 2);
    }
    function atEnd(container) {
      return (Math.ceil(container.scrollLeft + container.clientWidth) >= container.scrollWidth - 2);
    }

    function scrollByCard(direction = 1) {
      if (!scrollContainer) return;
      const step = getStep();
      if (!step) return;

      if (direction === 1) {
        if (atEnd(scrollContainer)) {
          scrollContainer.scrollTo({ left: 0, behavior: 'smooth' });
          console.log('slider: reached end -> wrap to start');
          return;
        }
      } else {
        if (atStart(scrollContainer)) {
          const maxLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
          scrollContainer.scrollTo({ left: Math.max(0, maxLeft), behavior: 'smooth' });
          console.log('slider: reached start -> wrap to end');
          return;
        }
      }

      scrollContainer.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    function calcOffset(item) {
      const itemRect = item.getBoundingClientRect();
      const containerRect = scrollContainer.getBoundingClientRect();
      return Math.round(itemRect.left - containerRect.left + scrollContainer.scrollLeft);
    }

    function scrollToItem(item) {
      if (!item || !scrollContainer) return;
      const left = calcOffset(item);
      scrollContainer.scrollTo({ left, behavior: 'smooth' });
    }

    const clickHandler = (e) => {
      const item = e.target.closest(itemSelector);
      if (!item || !track.contains(item)) return;

      const anchor = e.target.closest('a');
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href || href === '#') {
          e.preventDefault();
          scrollToItem(item);
        } else {
          console.log('slider: clique em link -> navegando', href);
        }
        return;
      }

      e.preventDefault();
      scrollToItem(item);
      console.log('slider: clicked item -> scroll (section id:', section.id || 'no-id', ')');
    };

    track.removeEventListener('click', clickHandler);
    track.addEventListener('click', clickHandler, false);

    const nextHandler = (e) => { e.preventDefault(); scrollByCard(1); };
    const prevHandler = (e) => { e.preventDefault(); scrollByCard(-1); };

    if (btnNext) { btnNext.removeEventListener('click', nextHandler); btnNext.addEventListener('click', nextHandler); }
    if (btnPrev) { btnPrev.removeEventListener('click', prevHandler); btnPrev.addEventListener('click', prevHandler); }

    getAll().forEach(el => {
      if (!el.style.cursor) el.style.cursor = 'pointer';
      if (!el.hasAttribute('role')) el.setAttribute('role','button');
    });

    const autoplayMs = parseInt(section.getAttribute('data-autoplay'), 10);
    if (autoplayMs > 0) {
      let timer = null;

      function startAutoplay() {
        timer = setInterval(() => scrollByCard(1), autoplayMs);
      }

      function stopAutoplay() {
        clearInterval(timer);
      }

      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);
      scrollContainer.addEventListener('touchstart', stopAutoplay, { passive: true });
      scrollContainer.addEventListener('touchend', startAutoplay, { passive: true });

      startAutoplay();
    }

    console.log('initSectionSliderInstance: inicializado section', section.id || section,
                'itemSelector:', itemSelector,
                'btnPrev:', !!btnPrev, 'btnNext:', !!btnNext,
                'scrollContainer:', scrollContainer && (scrollContainer.id || scrollContainer.className || scrollContainer.tagName));
    return { section, slide, track, scrollContainer, itemSelector, scrollToItem, scrollByCard };
  }

  function enableDragScroll(container) {
 
    // Suporte a toque (mobile)
    let startTouchX = 0;
    container.addEventListener('touchstart', (e) => {
      startTouchX = e.touches[0].pageX;
      scrollLeft = container.scrollLeft;
    });

    container.addEventListener('touchmove', (e) => {
      const touchX = e.touches[0].pageX;
      const walk = (touchX - startTouchX) * 1.2;
      container.scrollLeft = scrollLeft - walk;
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  // aqui aplicamos a UI e então inicializamos os sliders
  ready(() => {
    requestAnimationFrame(() => {
      applyJsUiToSections();
      requestAnimationFrame(initAllSectionSliders);
    });
  });

  window.__initAllSectionSliders = initAllSectionSliders;
  window.__initSectionSliderInstance = initSectionSliderInstance;

})();